const STATUS = {
    ready: { message: '人脸清晰，请保持不动', level: 'ready' },
    loading: { message: '正在准备人脸识别…', level: 'loading' },
    noFace: { message: '请将脸部移入取景框', level: 'warning' },
    multipleFaces: { message: '请仅保留一人入镜', level: 'warning' },
    tooSmall: { message: '请靠近一些', level: 'warning' },
    tooLarge: { message: '请稍微后退', level: 'warning' },
    offCenter: { message: '请保持脸部居中', level: 'warning' },
    unavailable: { message: '人脸识别不可用，可从相册选择照片', level: 'error' },
};

function publicAsset(path) {
    const base = process.env.BASE_URL || '/';
    return `${base.replace(/\/$/, '')}/${path}`;
}

export function getFaceStatus(name) {
    return STATUS[name] || STATUS.unavailable;
}

export async function createFaceDetector(runningMode) {
    const vision = await import(/* webpackChunkName: "face-detection" */ '@mediapipe/tasks-vision');
    const fileset = await vision.FilesetResolver.forVisionTasks(publicAsset('mediapipe/wasm'));

    return vision.FaceDetector.createFromOptions(fileset, {
        baseOptions: {
            modelAssetPath: publicAsset('mediapipe/models/blaze_face_short_range.tflite'),
        },
        runningMode,
        minDetectionConfidence: 0.65,
        minSuppressionThreshold: 0.3,
    });
}

export function evaluateFaceDetections(detections, width, height) {
    if (!detections || detections.length === 0) {
        return 'noFace';
    }
    if (detections.length > 1) {
        return 'multipleFaces';
    }

    const box = detections[0].boundingBox;
    if (!box || !width || !height) {
        return 'noFace';
    }

    const faceWidth = box.width / width;
    const faceHeight = box.height / height;
    const faceCenterX = (box.originX + box.width / 2) / width;
    const faceCenterY = (box.originY + box.height / 2) / height;

    if (faceWidth < 0.18 || faceHeight < 0.18) {
        return 'tooSmall';
    }
    if (faceWidth > 0.72 || faceHeight > 0.72) {
        return 'tooLarge';
    }
    if (Math.abs(faceCenterX - 0.5) > 0.16 || Math.abs(faceCenterY - 0.48) > 0.22) {
        return 'offCenter';
    }
    return 'ready';
}

export async function checkPhotoFace(file) {
    const detector = await createFaceDetector('IMAGE');
    const sourceUrl = URL.createObjectURL(file);

    try {
        const image = new Image();
        await new Promise((resolve, reject) => {
            image.onload = resolve;
            image.onerror = reject;
            image.src = sourceUrl;
        });
        const result = detector.detect(image);
        return evaluateFaceDetections(result.detections, image.naturalWidth, image.naturalHeight);
    } finally {
        URL.revokeObjectURL(sourceUrl);
        detector.close();
    }
}
